import { Skeleton } from '@hungryroot/pho';
import { Divider } from '../Divider/Divider';
import styles from './RDPLoading.module.css';

export function RDPLoading() {
  return (
    <>
      <Skeleton className={styles['image-skeleton']} />
      <div className={styles.section}>
        <Skeleton className={styles['product-info-skeleton']} />
        <Skeleton className={styles['product-info-skeleton']} />
        <Skeleton className={styles['product-info-skeleton']} />
        <Skeleton className={styles['product-info-skeleton']} />
      </div>
      <Divider />
      <div className={styles.section}>
        <Skeleton className={styles['content-skeleton']} />
        <Skeleton className={styles['content-skeleton']} />
        <Skeleton className={styles['content-skeleton']} />
      </div>
    </>
  );
}
